import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import Skeleton from 'react-loading-skeleton';
import Img from 'react-image';
import get from 'lodash.get';
import { useSpaces, useSpacesContext } from './Spaces';

var Loader = function Loader(_ref) {
  var skeletonProps = _ref.skeletonProps,
      rest = _objectWithoutPropertiesLoose(_ref, ["skeletonProps"]);

  return React.createElement("span", rest, React.createElement(Skeleton, skeletonProps));
};

Loader.defaultProps = {
  skeletonProps: {
    height: '100%'
  }
};

var SpacesImage = function SpacesImage(_ref2) {
  var spaceId = _ref2.spaceId,
      payerId = _ref2.payerId,
      imageType = _ref2.imageType,
      fallback = _ref2.fallback,
      skeletonProps = _ref2.skeletonProps,
      props = _objectWithoutPropertiesLoose(_ref2, ["spaceId", "payerId", "imageType", "fallback", "skeletonProps"]);

  var _useSpaces = useSpaces(spaceId || payerId),
      _useSpaces$ = _useSpaces[0],
      space = _useSpaces$ === void 0 ? {} : _useSpaces$;

  var _ref3 = useSpacesContext() || {},
      loading = _ref3.loading;

  var id = spaceId || payerId || space.id;
  var url = get(space, imageType);

  if (!url && loading) {
    return React.createElement(Loader, Object.assign({
      "data-testid": "space-" + imageType + "-" + id + "-loading",
      skeletonProps: skeletonProps
    }, props));
  } // We can probably remove this at some point once our spaces data is complete


  if (!url && !loading && fallback) {
    url = fallback;
  }

  if (!url || !id) return null;
  return React.createElement(Img, Object.assign({
    "data-testid": "space-" + imageType + "-" + id,
    src: url,
    alt: "Space " + imageType,
    loader: React.createElement(Loader, Object.assign({
      "data-testid": "space-" + imageType + "-" + id,
      skeletonProps: skeletonProps
    }, props))
  }, props));
};

SpacesImage.defaultProps = {
  imageType: 'url'
}; // Adapted from https://github.com/Availity/availity-react/blob/master/packages/reactstrap-validation-select/AvResourceSelect.js

var ucFirst = function ucFirst(str) {
  return str && str.charAt(0).toUpperCase() + str.slice(1);
};

SpacesImage.create = function (defaults) {
  var SpecificSpacesImage = function SpecificSpacesImage(props) {
    return React.createElement(SpacesImage, Object.assign({}, defaults, props));
  };

  SpecificSpacesImage.displayName = "Spaces" + ucFirst(defaults.imageType);
  return SpecificSpacesImage;
};

export default SpacesImage;